module.exports = __webpack_public_path__ + "img/Wp_2035.99256bf5.png";